export default {
  cropResource: {
    crop: 'Clip',
    clip: 'Clip',
    cropMsg: 'Clip failure',
  },
  groupSetting: {
    removeGroup: 'Ungroup',
  },
  disabledStyleTips:
    'The current layer has set %{animationName} animation, modify the initial state of %{animationName} in the animation panel',
  basicStyle2: {
    title: 'Position & Size',
    rotationAngle: 'Rotation',
    Opacity: 'Opacity',
    scaleX: 'Scale X',
    scaleY: 'Scale Y',
    anchoredX: 'Anchored X',
    anchoredY: 'Anchored Y',
    defaultAnimation: 'Dragon Bone action',
    sequenceFrame: 'Sequence',
    visible: 'visible',
    scaleTitle: 'Scale',
    scaleXText: 'Scale X',
    scaleYText: 'Scale Y',
    pivotTitle: 'Pivot',
    pivotXText: 'Pivot X',
    pivotYText: 'Pivot Y',
    pivotDesc: 'Green dot is the pivot.<br/>Move green dot to adjust pivot.',
  },
  screenAdapter: {
    title: 'Screen adaptation',
  },
  align: {
    left: 'Align left',
    horizontalCenter: 'Centered horizontally',
    right: 'Align right',
    top: 'Top align',
    verticalCenter: 'Center vertically',
    bottom: 'Bottom align',
    horizontalSpacing: 'Horizontal dispersion alignment',
    verticalSpacing: 'Vertical dispersion alignment',
  },
  nine: {
    title: 'Nine Patch Drawable Grahpic',
    left: 'Left',
    right: 'Right',
    top: 'Top',
    bottom: 'Bottom',
  },
  reuseLayout: {
    horizontalText: 'Reuse vertical screen position configuration',
    verticalText: 'Reuse horizontal screen position configuration',
  },
  resetSize: {
    title: 'Reset size',
  },
  dragonBoneSetting: {
    title: 'Animation selection',
    animationName: 'Animation selection',
    playOnAwake: 'autoplay upon open',
    playSetting: 'Playback Settings',
    playLoop: 'Loop',
    playSpeed: 'Play speed',
    startPlay: 'Start',
    pausePlay: 'Pause',
  },
  screenSplitProp: {
    visibleContent: '[Show & Hide]  Separate Setting',
    visibleTips:
      'The show and hide status of the current layer can be set separately in different values for horizontal and vertical screens.',
    layoutContent: '[Position & Size] Separate Setting',
    layoutTips:
      'The position & size of the current layer can be set separately in different values for horizontal and vertical screens. Default setting separately and cannot be changed.',
    adaptationContent: '[Screen adaptation] Separate Setting',
    adaptationTips:
      'The screen adaptation of the current layer can be set separately in different values for horizontal and vertical screens.',
    scaleContent: '[Scaling] Separate Setting',
    scaleTips:
      'The scaling of the current layer can be set separately in different values for horizontal and vertical screens.',
    pivotContent: '[Anchor] Separate Setting',
    pivotTips:
      'The anchor of the current layer can be set separately in different values for horizontal and vertical screens.',
    fontSizeContent: '[Font Size] Separate Setting',
    fontSizeTips:
      'The font size of the current text can be set separately in different values from horizontal and vertical screens.',
    dragonBoneContent: '[Spine]  Separate Setting',
    dragonBoneTips:
      'Part of the spine parameter of the current layer can be set separately in different values for horizontal and vertical screens, including animation selection, loop, play speed.',
    tweenPositionContent: '[Displacement Offset] Separate Setting',
    tweenPositionTips:
      'The displacement offset of the current layer can be set separately in different values from horizontal and vertical screens.',
    tweenScaleContent: '[Scale Ratio] Separate Setting',
    tweenScaleTips:
      'The zoom scale of the current zoom animation can be set to different values for landscape and portrait modes.',
    rotationContent: '[Rotation] Separate Setting',
    rotationTips:
      'The rotation of the current layer can be set separately in different values for horizontal and vertical screens.',
  },
  ratioLock: 'Lock Aspect Ratio',
}
